export default __webpack_public_path__ + "static/media/emptyImage.b2ae0a6e.png";